module.exports = __webpack_public_path__ + "img/37.b77c05fd.jpg";